import { render } from "./HeadlinesView.vue?vue&type=template&id=d29fb998"
import script from "./HeadlinesView.vue?vue&type=script&lang=js"
export * from "./HeadlinesView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/BNRY-technical-assessment/BNRY-technical-assessment/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__